<template>
  <div class="exception">
    <div class="container flex flex_center">
      <img :src="model.src" alt="404" class="exception_img">
      <div class="exception_content">
        <h1>{{ model.title }}</h1>
        <p class="desc">{{ model.desc }}</p>
        <button @click="goHome" class="go_home">返回首页</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return {
      model: {
        src: "https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg",
        title: "404",
        desc: "抱歉，你访问的页面不存在"
      }
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    }
  },
  mounted(){
    console.log(this.$route);
  }
};
</script>
<style lang="less" scoped>
  .exception {
    .container{
      justify-content: center;
      height: 80vh;
    }
    &_img {
      flex: 0 0 40%;
      width: 40%;
      margin-right: 50px;
    }

    &_content {
      h1 {
        line-height: 72px;
        margin-bottom: 24px;
        font-size: 72px;
        color: #434e59;
        font-weight: 600;
      }

      .desc {
        margin-bottom: 16px;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .go_home{
      padding: 5px 20px;
      color: #fff;
      font-size: 14px;
      background: #2678CB;
      border-radius: 4px;
    }
  }
</style>
